
import { IAlert, RouterName } from "@/models/common";
import { messageType } from "@/models/message";
import { IResultPayment } from "@/models/payment";
import { defineComponent, onMounted, Ref, ref } from "vue";
import router from "@/router";
import { RequestKindTypes } from "@/models/request";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "Order Result",
  props: {
    res: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const {t} = useI18n();

    const utf8 = require("utf8");
    const data = atob(props.res);
    const resString = utf8.encode(data);
    const resObject: IResultPayment = JSON.parse(resString);

    const alert: Ref<IAlert> = ref({
      type: messageType.ERROR,
      content: "",
    });

    onMounted(() => {
      if (resObject.ResultCode === 0 && !resObject.Exception) {
        alert.value.type = messageType.INFO;
        alert.value.content = `${resObject.AmountText}원이 결제 되었습니다.`;
        alert.value.callback = () => {
          router.replace({
            name:
              resObject.RequestKind === RequestKindTypes.OnlineCare
                ? RouterName.ONLINE_CARE_REQUEST_VIEW
                : RouterName.SECOND_OPINION_REQUEST_VIEW,
            params: { id: resObject.RequestKey.valueOf() },
          });
        };
      }
    });

    return { alert, resObject, t };
  },
});
